var de_DE = function(n, ord) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
};
var plural = function(value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  if (key in data) return data[key];
  return data.other;
};

module.exports = {
  comms: {
    error: {
      aisloopdetected: {
        title: function(d) { return "Unable to install"; },
        message: function(d) { return "Install failed, please try again later."; }
      },
      connectionunexpectedlyterminated: {
        title: function(d) { return "Unable to install"; },
        message: function(d) { return "Install failed, please try again later."; }
      },
      connecttointernetfailure: {
        title: function(d) { return "Unable to connect to Internet."; },
        message: function(d) { return "Could not connect to the Internet, please try again later."; }
      },
      deviceconnectionerror: {
        title: function(d) { return "Unable to connect to " + d.deviceName; },
        message: function(d) { return "Error connecting with " + d.deviceName + ". Please make sure your Fitbit is nearby and powered on and then please try again."; }
      },
      disconnected: {
        title: function(d) { return "Unable to connect to " + d.deviceName; },
        message: function(d) { return "Error connecting with " + d.deviceName + ". Please make sure your Fitbit is nearby and powered on and then please try again."; }
      },
      hwfailure: {
        title: function(d) { return "Unable to install"; },
        message: function(d) { return "Install failed, please try again later."; }
      },
      joinfailure: {
        title: function(d) { return "Unable to join Wi-Fi"; },
        message: function(d) { return "Please try again or add a new Wi-Fi access point via “Devices/" + d.deviceName + "/Wi-Fi settings”."; }
      },
      nocontentavailable: {
        title: function(d) { return "Unable to install"; },
        message: function(d) { return "Install failed, please try again later"; }
      },
      sitesyncfailure: {
        title: function(d) { return "Unable to install"; },
        message: function(d) { return "Install failed, please try again later."; }
      },
      tlshandshakefailure: {
        title: function(d) { return "Unable to connect to Internet."; },
        message: function(d) { return "Could not connect to the Internet, please try again later."; }
      },
      unknown: {
        title: function(d) { return "Unable to install"; },
        message: function(d) { return "Install failed, please try again later."; }
      },
      unsupportedauthtype: {
        title: function(d) { return "Unable to install"; },
        message: function(d) { return "Install failed, please try again later."; }
      },
      wificonnectionerror: {
        title: function(d) { return "Unable to connect to Wi-Fi"; },
        message: function(d) { return "We can’t find any saved Wi-Fi access points. Please add a new Wi-Fi access point via “Devices/" + d.deviceName + "/Wi-Fi settings” or try again."; }
      },
      wificonnectionissue: {
        title: function(d) { return "Unable to connect to Wi-Fi"; },
        message: function(d) { return "We can’t find any saved Wi-Fi access points. Please add a new Wi-Fi access point via “Devices/" + d.deviceName + "/Wi-Fi settings” or try again."; }
      },
      wifiinitfailure: {
        title: function(d) { return "Unable to install"; },
        message: function(d) { return "Could not initialize Wi-Fi, please reset " + d.deviceName + " and try again."; }
      },
      wifilowbattery: {
        title: function(d) { return d.deviceName + " battery too low"; },
        message: function(d) { return d.deviceName + " battery is too low to install an app that requires Wi-Fi. Charge your " + d.deviceName + " before installing this app."; }
      },
      wifinotsetup: {
        title: function(d) { return "This app needs " + d.deviceName + " Wi-Fi setup to install"; },
        message: function(d) { return "You don’t have any networks set up. Go to \"Devices/" + d.deviceName + "/Wi-Fi\" and add a Wi-Fi network before installing this app."; }
      }
    },
    permissions: {
      access_activity: {
        description: function(d) { return "App will get access to Activity data"; },
        label: function(d) { return "Activity"; }
      },
      access_heart_rate: {
        description: function(d) { return "App will get access to your heart rate data"; },
        label: function(d) { return "Heart Rate"; }
      },
      access_internet: {
        description: function(d) { return "App will get access to your Internet"; },
        label: function(d) { return "Internet"; }
      },
      access_location: {
        description: function(d) { return "App will get access to your location data"; },
        label: function(d) { return "Location"; }
      },
      access_background_location: {
        description: function(d) { return "App will get access to your background location data"; },
        label: function(d) { return "Background Location"; }
      },
      access_calendar: {
        description: function(d) { return "App will get access to your mobile calendar data"; },
        label: function(d) { return "Calendar"; }
      },
      access_user_profile: {
        description: function(d) { return "App will get access to User Profile data"; },
        label: function(d) { return "User Profile"; }
      },
      run_background: {
        description: function(d) { return "App will run in the background"; },
        label: function(d) { return "Run in Background"; }
      },
      access_exercise: {
        description: function(d) { return "App will be able to create exercises"; },
        label: function(d) { return "Create Exercise"; }
      },
      access_app_cluster_storage: {
        description: function(d) { return "Share data between apps from the same developer"; },
        label: function(d) { return "Group Storage"; }
      },
      device_notifications: {
        description: function(d) { return "Allow apps and clock faces to send notifications on your smartphone"; },
        label: function(d) { return "Device Notifications"; }
      },
      mobile_notifications: {
        description: function(d) { return "Allow apps and clock faces to display notifications on your smartphone"; },
        label: function(d) { return "Mobile Notifications"; }
      },
      access_sleep: {
        description: function(d) { return "App will get access to your sleep data"; },
        label: function(d) { return "Sleep"; }
      },
      _toggle_all: {
        description: function(d) { return "Turns all permissions on or off"; },
        label: function(d) { return "Select All"; }
      }
    }
  },
  fetch: {
    error: {
      unknown: {
        message: function(d) { return "Problem making request, please close and reopen the gallery to try again"; }
      }
    }
  },
  device: {
    deviceName: function(d) { return "Device"; }
  },
  component: {
    AppDetails: {
      bannerAltText: function(d) { return "App Banner"; },
      ColumnDescriptor: {
        updated: function(d) { return "Updated"; },
        size: function(d) { return "Size"; },
        version: function(d) { return "Version"; },
        status: function(d) { return "Status"; },
        developer: function(d) { return "Offered by"; }
      },
      privateStatusText: function(d) { return "Private"; },
      publicStatusText: function(d) { return "Public"; },
      contactDeveloper: function(d) { return "Contact Developer"; },
      paidBannerText: function(d) { return "This item may require payment, which is solely managed by the developer."; },
      permissionLinkText: function(d) { return "Permissions"; },
      removeButtonText: function(d) { return "Remove"; },
      reportText: function(d) { return "If you feel like this app is in violation of any laws, or is threatening to any individual,"; },
      reportLinkText: function(d) { return "please report it."; },
      reportButtonText: function(d) { return "Report"; },
      customizeButtonText: function(d) { return "Customize"; },
      customizeClockfaceButtonText: function(d) { return "Customize clock face"; },
      settingsLinkText: function(d) { return "Settings"; },
      showMoreButtonText: function(d) { return "Show More"; },
      flags: {
        RESTRICTED_FOR_REGION: function(d) { return "This " + d.type + " isn't available in your region yet."; }
      }
    },
    Category: {
      viewAllText: function(d) { return "View All"; }
    },
    ErrorModal: {
      okButtonText: function(d) { return "OK"; }
    },
    ContinueInstallModal: {
      title: function(d) { return "Continue installing?"; },
      text: function(d) { return "Some applications did not finish installing. Do you want to continue installing them now?"; },
      cancelButtonText: function(d) { return "Later"; },
      continueButtonText: function(d) { return "Continue"; }
    },
    AppIsPaidNotice: {
      textClock: function(d) { return "This clock requires payment and is managed by a third-party developer that is "; },
      textApp: function(d) { return "This app requires payment and is managed by a third-party developer that is "; },
      title: function(d) { return "Payment Required"; },
      notEndorsed: function(d) { return "not endorsed by Fitbit."; },
      caution: function(d) { return "Proceed with caution."; }
    },
    AppIsPaidModal: {
      title: function(d) { return "\"" + d.appName + "\" Payment"; },
      textClock: function(d) { return "This clock requires payment and is managed by a third-party developer that is "; },
      textApp: function(d) { return "This app requires payment and is managed by a third-party developer that is "; },
      notEndorsed: function(d) { return "not endorsed by Fitbit."; },
      changeMindClock: function(d) { return "If you change your mind about the purchase, please switch to another clock in the "; },
      changeMindApp: function(d) { return "If you change your mind about the purchase, please switch to another app in the "; },
      fitbitClockGallery: function(d) { return "Fitbit Clock Gallery."; },
      fitbitAppGallery: function(d) { return "Fitbit App Gallery."; },
      caution: function(d) { return "Proceed with caution."; }
    },
    AppIsPrivateNotice: {
      text: function(d) { return "The content has not been reviewed by Fitbit."; },
      title: function(d) { return "Private app"; },
      caution: function(d) { return "Only install applications from trusted sources."; }
    },
    PermissionModal: {
      title: function(d) { return "\"" + d.appName + "\" Needs Permissions"; },
      text: function(d) { return "For the best experience, select all permissions below"; },
      selectAllButtonText: function(d) { return "Select All"; },
      allowButtonText: function(d) { return "Proceed"; },
      disallowButtonText: function(d) { return "Cancel"; }
    },
    UninstallModal: {
      Title: function(d) { return "Uninstall " + d.appName; },
      Content: function(d) { return "This will remove all data associated with the app"; },
      UninstallText: function(d) { return "Uninstall"; },
      CancelText: function(d) { return "Cancel"; },
      TilesText: function(d) { return "The Following tiles will also be removed"; }
    },
    UninstallTileModal: {
      title: function(d) { return "Remove " + d.tileName + "?"; },
      content: function(d) { return d.tileName + " will be removed and it will no longer be displayed in My Tiles?"; },
      UninstallText: function(d) { return "Remove"; },
      loading: function(d) { return "Loading..."; }
    },
    TooFewTilesModal: {
      title: function(d) { return "Can’t remove this tile"; },
      appTitle: function(d) { return "Can’t remove this app"; },
      gotIt: function(d) { return "Got it"; },
      content: function(d) { return d.tileName + " cannot be removed as the minimum tile number is " + d.minTileNumber + "."; },
      appContent: function(d) { return "This app has a tile linked to it and the minimum number of tiles is " + d.minTileNumber + ". Add another tile before removing this one."; }
    },
    InstallTileModal: {
      title: function(d) { return "Activate Tile"; },
      content: function(d) { return "You are allowed max " + d.maxTileNumber + " tiles on your " + d.deviceName + ". Please remove a tile in order to add the " + d.tileName + " tile in the list"; },
      cancelText: function(d) { return "Cancel"; },
      continueText: function(d) { return "Continue"; }
    },
    InstallTileAndAppModal: {
      title: function(d) { return "Activate Tile"; },
      content: function(d) { return "The associated app with this tile is not installed in your system. Would you like to add it as well?"; },
      cancelText: function(d) { return "Cancel"; },
      continueText: function(d) { return "Continue"; }
    },
    PrivateModal: {
      Title: function(d) { return "This " + d.type + " is private"; },
      Content: function(d) { return "This " + d.type + " is privately published and has not undergone the review process for apps published within the Fitbit Gallery. Only install applications from trusted sources."; },
      InstallText: function(d) { return "Proceed"; },
      CancelText: function(d) { return "Return"; }
    },
    Ratings: {
      noRatingsText: function(d) { return "No ratings yet"; },
      numberOfRatingsText: function(d) { return plural(d.numRatings, 0, de_DE, { one: d.numRatings + " Rating", other: d.numRatings + " Ratings" }); },
      installsText: function(d) { return "Installs"; },
      youRatedText: function(d) { return "You rated"; },
      removeText: function(d) { return "Change"; },
      rateThisItemText: function(d) { return "Rate this app"; },
      rateClockface: function(d) { return "Rate Clockface"; },
      ratingText: function(d) { return "Ratings"; },
      thankYouText: function(d) { return "Thank you for rating!"; }
    },
    ReportModal: {
      Cancel: function(d) { return "Cancel"; },
      Error: function(d) { return "Please pick a type to report"; },
      Report: function(d) { return "Report"; },
      Title: function(d) { return "Report This App"; },
      ReportTypes: {
        buggy: function(d) { return "Buggy / Doesn't Work"; },
        sexual_content: function(d) { return "Sexual Content"; },
        graphic_violence: function(d) { return "Graphic Violence"; },
        abusive: function(d) { return "Hateful or Abusive"; },
        harmful_to_fitbit: function(d) { return "Harmful to Fitbit Device"; },
        harmful_to_mobile: function(d) { return "Harmful to Mobile Device"; },
        copyright: function(d) { return "Copyright Violation"; },
        trademark: function(d) { return "Trademark Violation"; },
        payment: function(d) { return "Payment Issue"; },
        others: function(d) { return "Other Objection"; }
      }
    },
    ReportTextModal: {
      Cancel: function(d) { return "Cancel"; },
      Placeholder: function(d) { return "Please provide a short description of why you are reporting this app"; },
      Submit: function(d) { return "Submit"; },
      Title: function(d) { return "Tell us more"; }
    },
    ReportedModal: {
      Ok: function(d) { return "Ok"; },
      Title: function(d) { return "Your Report was Submitted"; },
      DMCATitle: function(d) { return "Report This App"; },
      DMCAText: function(d) { return "Please see detailed information for claiming Copyright / Trademark Infringement here"; },
      OtherText: function(d) { return "Thank you for taking the time to report this app. We will review it as soon as possible"; }
    },
    Search: {
      defaultRecsText: function(d) { return "Try searching for:"; },
      noResults: function(d) { return "Nothing found"; }
    },
    ErrorPage: {
      commonErrorText: function(d) { return "Sorry, an error has occurred. Please go back and try again later."; }
    },
    LoadingPage: {
      spinnerAltText: function(d) { return "loading"; }
    },
    PromoHeader: {
      description: function(d) { return "Visit our App Gallery and find new and exciting apps for your " + d.deviceName + "."; },
      getAppsButtonText: function(d) { return "Check It Out"; },
      title: function(d) { return "Get More Apps"; }
    },
    Navigation: {
      directLinkBackText: function(d) { return "Back"; }
    }
  },
  page: {
    Collection: {
      Filters: {
        FREE: function(d) { return "Free"; },
        PAID: function(d) { return "Paid"; }
      }
    },
    App: {
      InstallButtonState: {
        DISABLED: function(d) { return "Install"; },
        INSTALL_FAILED: function(d) { return "Failed Install"; },
        INSTALLED: function(d) { return "Installed"; },
        NOT_INSTALLED: function(d) { return "Install"; },
        PENDING_INSTALL: function(d) { return "Retry Install"; },
        UPDATE_AVAILABLE: function(d) { return "Update"; },
        UNINSTALL: function(d) { return "Uninstall"; },
        UPDATE_FAILED: function(d) { return "Failed Update"; }
      },
      Navigation: {
        backText: function(d) { return "Back"; }
      },
      Details: {
        cannotInstallNotice: function(d) { return "This app is not compatible with your Fitbit device."; },
        cannotInstallNoticeNoVersion: function(d) { return "To install this app, make sure the Fitbit app on your phone and your Fitbit device have the latest update."; },
        cannotInstallNoticeNoVersionLink: function(d) { return "Learn more"; },
        cannotInstallNoticeDeviceDisconnected: function(d) { return "This app cannot be installed on your device. Your device is not connected."; },
        compatibilityNotice: function(d) { return "This " + d.type + " is not optimized for your device but you can still use it once installed. If you encounter issues please "; },
        compatibilityNoticeLink: function(d) { return "contact the developer."; },
        descriptionSectionTitle: function(d) { return "Description"; },
        detailsSectionTitle: function(d) { return "Details"; },
        screenshotsSectionTitle: function(d) { return "Screenshots"; },
        fromDeveloperSectionTitle: function(d) { return "More from developer"; },
        permissionIssueNoticeSingluar: function(d) { return "This app requires the " + d.permissionNames + " permission in order to function correctly."; },
        permissionIssueNoticePlural: function(d) { return "This app requires the " + d.permissionNames + " permissions in order to function correctly."; },
        permissionIssueNoticeNameJoiner: function(d) { return "and"; },
        permissionIssueNoticeLink: function(d) { return "Learn how to troubleshoot."; },
        parentAppSectionTitle: function(d) { return "The App"; },
        viewApp: function(d) { return "View App"; }
      },
      buttons: {
        cancel: function(d) { return "Cancel"; }
      },
      Labels: {
        cannotInstallNotice: {
          key: function(d) { return "Not available"; },
          title: function(d) { return "Not available"; },
          message: function(d) { return "This app is not compatible with your Fitbit device."; }
        },
        cannotInstallNoticeNoVersion: {
          key: function(d) { return "Not available"; },
          title: function(d) { return "Not available"; },
          message: function(d) { return "To install this app, make sure the Fitbit app on your phone and your Fitbit device have the latest update."; },
          link: function(d) { return "Learn more"; }
        },
        cannotInstallNoticeNoRegion: {
          key: function(d) { return "Not available"; },
          title: function(d) { return "Not available"; },
          message: function(d) { return "This app isn't available in your region yet."; }
        },
        cannotInstallNoticeDeviceDisconnected: {
          key: function(d) { return "Not available"; },
          title: function(d) { return "Not available"; },
          message: function(d) { return "This app cannot be installed on your device. Your device is not connected."; }
        },
        compatibility: {
          key: function(d) { return "Not Optimized"; },
          title: function(d) { return "App is not optimized"; },
          message: function(d) { return "This app is not optimized for your device but you can still use it once installed. If you encounter issues please "; },
          link: function(d) { return "contact the developer."; }
        },
        paid: {
          key: function(d) { return "Paid"; },
          title: function(d) { return "This app is paid"; },
          message: function(d) { return "This app may require payment, which is solely managed by the developer."; }
        }
      }
    },
    AppGallery: {
      installedPageName: function(d) { return "My Apps"; },
      listPageName: function(d) { return "All Apps"; },
      pageName: function(d) { return "Apps"; }
    },
    AppList: {
      Digest: {
        appIconAltText: function(d) { return "App Icon"; },
        removeButtonText: function(d) { return "Remove"; }
      }
    },
    ClockDetails: {
      InstallButtonState: {
        DISABLED: function(d) { return "Install"; },
        INSTALL_FAILED: function(d) { return "Failed Install"; },
        INSTALLED: function(d) { return "Selected"; },
        NOT_INSTALLED: function(d) { return "Install"; },
        PENDING_INSTALL: function(d) { return "Retry Install"; },
        UPDATE_AVAILABLE: function(d) { return "Update"; },
        UPDATE_FAILED: function(d) { return "Failed Update"; }
      }
    },
    Clock: {
      InstallButtonState: {
        DISABLED: function(d) { return "Select"; },
        INSTALL_FAILED: function(d) { return "Failed Select"; },
        INSTALLED: function(d) { return "Selected"; },
        NOT_INSTALLED: function(d) { return "Select"; },
        PENDING_INSTALL: function(d) { return "Retry Select"; },
        UPDATE_AVAILABLE: function(d) { return "Update"; },
        UPDATE_FAILED: function(d) { return "Failed Update"; }
      },
      InstallButtonWaitModal: {
        title: function(d) { return "Please wait"; },
        content: function(d) { return "There is another clock install in progress. Please wait for it to finish before installing a new one"; },
        button: function(d) { return "Ok, I'll wait"; }
      },
      Navigation: {
        backText: function(d) { return "Back"; }
      },
      Details: {
        cannotInstallNotice: function(d) { return "This clock is not compatible with your Fitbit device."; },
        cannotInstallNoticeNoVersion: function(d) { return "To install this clock, make sure the Fitbit app on your phone and your Fitbit device have the latest update."; },
        cannotInstallNoticeNoVersionLink: function(d) { return "Learn more"; },
        cannotInstallNoticeDeviceDisconnected: function(d) { return "This clock cannot be installed on your device. Your device is not connected."; },
        descriptionSectionTitle: function(d) { return "Description"; },
        detailsSectionTitle: function(d) { return "Details"; },
        screenshotsSectionTitle: function(d) { return "Screenshots"; },
        fromDeveloperSectionTitle: function(d) { return "More from developer"; }
      },
      buttons: {
        cancel: function(d) { return "Cancel"; }
      },
      Labels: {
        cannotInstallNotice: {
          key: function(d) { return "Not available"; },
          title: function(d) { return "Not available"; },
          message: function(d) { return "This clock is not compatible with your Fitbit device."; }
        },
        cannotInstallNoticeNoVersion: {
          key: function(d) { return "Not available"; },
          title: function(d) { return "Not available"; },
          message: function(d) { return "To install this clock, make sure the Fitbit app on your phone and your Fitbit device have the latest update."; },
          link: function(d) { return "Learn more"; }
        },
        cannotInstallNoticeNoRegion: {
          key: function(d) { return "Not available"; },
          title: function(d) { return "Not available"; },
          message: function(d) { return "This clock isn't available in your region yet."; }
        },
        cannotInstallNoticeDeviceDisconnected: {
          key: function(d) { return "Not available"; },
          title: function(d) { return "Not available"; },
          message: function(d) { return "This clock cannot be installed on your device. Your device is not connected."; }
        },
        compatibility: {
          key: function(d) { return "Not Optimized"; },
          title: function(d) { return "Clock is not optimized"; },
          message: function(d) { return "This clock is not optimized for your device but you can still use it once installed. If you encounter issues please "; },
          link: function(d) { return "contact the developer."; }
        },
        paid: {
          key: function(d) { return "Paid"; },
          title: function(d) { return "This clock is paid"; },
          message: function(d) { return "This clock may require payment, which is solely managed by the developer."; }
        }
      }
    },
    ClockGallery: {
      installedPageName: function(d) { return "My " + d.deviceName; },
      listPageName: function(d) { return "All Clocks"; },
      pageName: function(d) { return "Clocks"; },
      MyClocks: {
        selectedTitle: function(d) { return "My Clock Faces"; },
        switching: function(d) { return "Switching..."; },
        help: {
          button: function(d) { return "What is this?"; },
          modal: {
            title: function(d) { return "My Clocks Faces"; },
            content: function(d) { return "You can save up to " + d.maxFavoriteClocks + " clock faces when you install them to your Fitbit. Keep the ones you like the most."; },
            button: function(d) { return "Ok, got it"; }
          }
        },
        details: {
          doneButton: function(d) { return "Done"; },
          settings: function(d) { return "Settings"; },
          addLoading: function(d) { return "Saving..."; },
          addButton: function(d) { return "Save clock face"; },
          removeLoading: function(d) { return "Removing..."; },
          removeButton: function(d) { return "Remove clock face"; },
          removeFavoriteButton: function(d) { return "Unsave clock face"; },
          appDetailsButton: function(d) { return "See all details"; },
          limitModal: {
            title: function(d) { return "Limit reached"; },
            content: function(d) { return "You have too many clocks saved. Please remove other clocks before adding new ones."; },
            button: function(d) { return "Ok, got it"; }
          },
          removeModal: {
            title: function(d) { return "Remove clock face?"; },
            content: function(d) { return "This will remove the clock face and all its previous settings."; },
            button: function(d) { return "Cancel"; },
            confirmButton: function(d) { return "Remove"; }
          }
        }
      }
    },
    InstalledClock: {
      description: function(d) { return "Visit the Clocks gallery to pick a Clock for your " + d.deviceName + "."; },
      descriptionClockExists: function(d) { return "Visit the Clocks gallery to pick a new Clock for your " + d.deviceName + "."; },
      developerText: function(d) { return "Created by " + d.developerName; },
      galleryButtonText: function(d) { return "Pick a Clock"; },
      galleryButtonTextClockExists: function(d) { return "Pick a New Clock"; }
    },
    Error: {
      backText: function(d) { return d.deviceName; },
      center: function(d) { return "Error"; }
    },
    NotFound: {
      NotFoundText: function(d) { return "Sorry - There is nothing here"; }
    },
    Outdated: {
      backText: function(d) { return d.deviceName; },
      text: function(d) { return "Your Fitbit mobile app needs to be updated before you can use the app gallery."; }
    },
    Permission: {
      backText: function(d) { return "Details"; },
      center: function(d) { return "Permissions"; },
      title: function(d) { return "Allow " + d.appName + " to Access"; },
      subtitle: function(d) { return "This app needs all these permissions to function properly. Please turn them on."; }
    },
    Search: {
      cancel: function(d) { return "Cancel"; },
      placeholderApps: function(d) { return "Search apps"; },
      placeholderClocks: function(d) { return "Search clock faces"; },
      placeholder: function(d) { return "Search for clocks or apps"; },
      header: function(d) { return "Search"; }
    },
    Home: {
      device: function(d) { return "Device"; },
      clocks: function(d) { return "Clocks"; },
      apps: function(d) { return "Apps"; },
      tiles: function(d) { return "Tiles"; }
    },
    MyApps: {
      myClocks: function(d) { return "My Clocks"; },
      myActiveClock: function(d) { return "My Active Clock"; },
      myApps: function(d) { return "My Apps"; },
      manage: function(d) { return "Manage"; },
      myTiles: function(d) { return "My Tiles"; },
      discoverMore: function(d) { return "Discover More"; },
      needsPermissions: function(d) { return "Needs Permissions"; }
    },
    ManageTiles: {
      title: function(d) { return "Manage Tiles (" + d.tilesCount + ")"; },
      arrange: function(d) { return "Arrange or remove at ease"; },
      add: function(d) { return "Add Tile"; },
      titleNoNumber: function(d) { return "Manage my tiles"; }
    }
  },
  premium: {
    subscribeToPremium: function(d) { return "Try Premium"; },
    availableOnlyToPremium: function(d) { return "Available only to Premium Users"; },
    includedWithPremium: function(d) { return "Included with Premium"; }
  },
  euAnnouncement: {
    title: function(d) { return "Important Update:"; },
    text: function(d) { return "Starting in June 2024, for users in the European Economic Area, only apps and clocks that are created by Fitbit and Google will be available in the Fitbit App Gallery. You can still use and enjoy the apps or clocks that are already installed on your device. Find out more " + d.link + "."; },
    link: function(d) { return "here"; }
  }
}